export default [
  // 启用标志
  {
    name: 'ENABLE_STATUS',
    value: 'FMEnableStatusEnum'
  },
  // 审核状态
  {
    name: 'FLOW_STATUS',
    value: 'FlowStatusEnum1'
  },
  // 是否在线
  {
    name: 'GATE_STATUS_ONLINE',
    value: 1
  },
  {
    name: 'GATE_STATUS_OFFLINE',
    value: 0
  },
  // DTU
  {
    name: 'GATE_TYPE_DTU',
    value: 0
  },
  // MN
  {
    name: 'GATE_TYPE_MN',
    value: 1
  },
  // MS
  {
    name: 'GATE_TYPE_MS',
    value: 2
  },
  // SN
  {
    name: 'GATE_TYPE_SN',
    value: 3
  }
]